import { render, staticRenderFns } from "./ActivitiesFormatter.vue?vue&type=template&id=688effbd&functional=true"
import script from "./ActivitiesFormatter.vue?vue&type=script&lang=js"
export * from "./ActivitiesFormatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports